<template>
  <div>
    <PaymentDetailModal
      v-if="isOpen"
      :open="isOpen"
      :id="selectedId"
      :modalClose="modalClose"
    />
    <PaymentRefundModal
      v-if="isRefundModalOpen"
      :open="isRefundModalOpen"
      :payment="selectedRefundPayment"
      :reload="reload"
      :modalClose="refundModalClose"
    />
    <div class="sm:-mx-8 sm:px-8 ">
      <div class="inline-block min-width-full rounded-lg shadow bg-white p-4">
        <div class="inline-flex items-center justify-start mt-4 mb-2 bg-white gap-2 w-full">
          <Multiselect
            class="max-w-[300px] mx-0"
            v-model="search.status"
            v-bind="setting"
          ></Multiselect>
          <div class="col-auto col-3 mr-2">
            <VueDatePicker
              v-model="search.searchStartDate"
              format="yyyy-MM-dd HH:mm:ss"
              :clearable="true"
              placeholder="검색 시작일"
              auto-apply
            />
          </div>
          <div class="col-auto col-3 ">
            <VueDatePicker
              v-model="search.searchEndDate"
              format="yyyy-MM-dd HH:mm:ss"
              :clearable="true"
              placeholder="검색 종료일"
              auto-apply
            />
          </div>
        </div>
        <div class="flex align-items-end justify-content-start flex-nowrap mb-4  bg-white">
          <b-input-group class="max-w-2xl">
            <b-input-group-prepend>
              <b-form-select :options="selectOptions" v-model="search.searchType"/>
            </b-input-group-prepend>
            <b-form-input id="inline-form-input-username"
                          placeholder="검색어를 입력하세요."
                          v-on:keyup.enter="handleSearch"
                          v-model="search.keyword">
            </b-form-input>
            <b-input-group-append>
              <Button :type="ButtonTypes.blue" :on-click="handleSearch" label="검색"/>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="flex align-items-end justify-content-start flex-nowrap mb-4 bg-white gap-2">
          <Button :type="ButtonTypes.green" :on-click="download" :loading="loading.excelExport" label="결제내역 다운로드"/>
          <Button :type="ButtonTypes.purple" :on-click="openRefundPage"  label="페이플 환불처리"/>
        </div>
        <b-table
          class="min-width-full"
          :busy="isLoading"
          responsive :fields="fields" :items="payments">
          <template #cell(productLessonTitle)="data">
            {{`${data.item.productLessonTitle ? data.item.productLessonTitle : data.item.productTitle}`}}
          </template>
          <template #cell(status)="data">
            <PaymentStatusBadge :payment-status="data.item.status" :status-ko="data.item.statusKo"/>
          </template>
          <template #cell(expiredAt)="data">
            {{ getDate(data.item.expiredAt)}}
          </template>
          <template #cell(paidAt)="data">
            {{ data.item.paidAt ? getDate(data.item.paidAt) : '-' }}
          </template>
          <template #cell(paymentKey)="data">
            <span v-on:click="copy(data.item.paymentKey)">{{ data.item.paymentKey }}</span>
          </template>
          <template #cell(amount)="data">
            {{ data.item.amount.toLocaleString("kr-KR") }}원
          </template>
          <template #cell(button)="data">
            <div class="text-right">
              <button class="btn btn-primary mx-2 text-white" v-on:click="showDetailModal(data.item.id)">상세</button>
              <button class="btn btn-danger text-white"
                      v-if="data.item.amount !== data.item.refundAmount && data.item.status !== 'waiting' && data.item.status !== 'vbank_issued' && data.item.status !== 'canceled' && data.item.status !== 'error'"
                      v-on:click="showRefundModal(data.item)">환불</button>
            </div>
          </template>
          <template #table-busy>
            <div class="text-center text-primary">
              <b-spinner small type="grow"></b-spinner> Loading...
            </div>
          </template>
        </b-table>
        <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="pageSize"
          @page-click="changePage"
        />
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/api";
import customDate from "@/util/custom-date";
import PaymentStatusBadge from "@/components/PaymentStatusBadge"
import {copyText} from "vue3-clipboard";
import moment from "moment";
import PaymentRefundModal from "@/components/modals/PaymentRefundModal.vue";
import PaymentDetailModal from "@/components/modals/PaymentDetailModal.vue";
import Button from "@/components/Button.vue";
import {ButtonTypes} from "@/util/enums";

export default {
  computed: {
    ButtonTypes() {
      return ButtonTypes
    }
  },
  components: {Button, PaymentRefundModal, PaymentDetailModal, PaymentStatusBadge},
  data() {
    return {
      payments: [],
      isInitialized: false,
      currentPage: 1,
      selectedId: "",
      selectedRefundPayment: "",
      pageSize: 30,
      totalPage: 0,
      totalRows: 0,
      isOpen: false,
      isRefundModalOpen: false,
      isLoading: false,
      selectOptions: [
        {value: 'productLessonTitle', text: '(필수) 수업명',},
        {value: 'productOptionTitle', text: '(옵션) 수업명',},
        {value: 'product', text: '내용',},
        {value: 'name', text: '구매자명',},
        {value: 'lessonAccessCode', text: '학생코드',},
        {value: 'paymentKey', text: '주문번호',},
        {value: 'phoneNumber', text: '전화번호',},
      ],
      setting: {
        mode: 'tags',
        value: [],
        closeOnSelect: false,
        placeholder: "결제상태",
        options: [
          {value: 'complete', label: '결제 완료'},
          {value: 'vbank_issued', label: '입금 대기중'},
          {value: 'refund', label: '환불'},
          {value: 'partial_refund', label: '부분 환불'},
          {value: 'waiting', label: '대기'},
          {value: 'error', label: '오류'},
        ],
        searchable: true,
        createOption: true
      },
      fields: [
        {
          label: '주문번호',
          key: 'paymentKey',
        },
        {
          label: '결제상태',
          key: 'status',
        },
        {
          label: '전화번호',
          key: 'phoneNumber',
        },
        {
          label: '결제자명',
          key: 'buyerName',
          thStyle: { minWidth: "80px" },
        },
        {
          label: '학생코드',
          key: 'accessCode',
        },
        {
          label: '결제수단',
          key: 'paymentTypeKo',
        },
        {
          label: '가격',
          key: 'amount',
        },
        {
          label: '결제일시',
          key: 'paidAt',
        },
        {
          label: '상품명',
          key: 'productTitle',
        },
        {
          label: '오프라인 수강 신청',
          key: "offlineClassApplication",
          thStyle: { minWidth: '50px' },
        },
        {
          label: '(필수) 수업',
          key: 'productLessonTitle',
          thStyle: { minWidth: "100px" },
        },
        {
          label: '(옵션) 수업',
          key: 'productLessonOptionTitle',
          thStyle: { minWidth: '200px' },
        },
        {
          label: '할인 내용',
          key: 'productLessonDiscountTitle',
          thStyle: { minWidth: "100px" },
        },
        {
          label: '요청사항',
          key: 'memo',
          thStyle: { minWidth: "100px" },
        },
        {
          label: '',
          key: 'button',
          thStyle: { minWidth: "140px" },
        }
      ],
      search: {
        status: ['complete'],
        searchType: "name",
        keyword: "",
        searchStartDate: moment().subtract(2, 'month').set({ hour: 0, minute: 0, second: 0}).toDate(),
        searchEndDate: null,
      },
      loading: {
        excelExport: false
      }
    }
  },
  watch: {
    'search.status': {
      handler() {
        if (this.isInitialized) {
          this.currentPage = 1
          this.updateQueryParams()
          this.getPagingList(1)
        }
      },
      deep: true
    },
    'search.searchStartDate'() {
      if (this.isInitialized && this.search.searchStartDate) {
        this.searchDate()
      }
    },
    'search.searchEndDate'() {
      if (this.isInitialized && this.search.searchEndDate) {
        this.searchDate()
      }
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.search.keyword = query.keyword
    }
    if (query.searchType) {
      this.search.searchType = query.searchType
    }
    if (query.status) {
      this.search.status = query.status.split(',')
    }
    if (query.searchStartDate) {
      this.search.searchStartDate = new Date(query.searchStartDate)
    }
    if (query.searchEndDate) {
      this.search.searchEndDate = new Date(query.searchEndDate)
    }
    
    this.getPagingList(this.currentPage)
    
    // 초기화 완료 후 watch 활성화
    this.$nextTick(() => {
      this.isInitialized = true
    })
  },
  methods: {
    copy(text){
      copyText(text, undefined, (err) => {
        this.$toast.show(err ? '복사 할 수 없습니다.' : '복사 완료',
          {
            position: "top-right",
            duration: 2000
          });
      })
    },
    modalClose(){
      this.isOpen = !this.isOpen
    },
    refundModalClose() {
      this.isRefundModalOpen = !this.isRefundModalOpen
    },
    reload(){
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.keyword) {
        query.keyword = this.search.keyword
      }
      if (this.search.searchType) {
        query.searchType = this.search.searchType
      }
      if (this.search.status && this.search.status.length > 0) {
        query.status = this.search.status.join(',')
      }
      if (this.search.searchStartDate) {
        query.searchStartDate = this.search.searchStartDate.toISOString()
      }
      if (this.search.searchEndDate) {
        query.searchEndDate = this.search.searchEndDate.toISOString()
      }
      
      this.$router.replace({ query })
    },
    showDetailModal(id) {
      this.selectedId = id
      this.modalClose()
    },
    showRefundModal(payment) {
      this.selectedRefundPayment = payment
      this.refundModalClose()
    },
    searchDate() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    getDate(date){
      return customDate.stringFormat(date)
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    openRefundPage() {
      window.open(process.env.VUE_APP_ENV === "production" ? "https://manager.payple.kr/payple/partner/?ACT_=PAYCARD" 
        : "https://demo-manager.payple.kr/payple/partner/?ACT_=PAYCARD")
    },
    getSearchStatusParams() {
      if (this.search.status.length === 0) {
        return ['complete', 'refund', 'partial_refund', 'vbank_issued', 'waiting', 'error']
      } else {
        if (this.search.status.includes('refund')) {
          return [...this.search.status, 'partial_refund']
        } else {
          return  this.search.status
        }
      }
    },
    download() {
      const selectStatus = this.getSearchStatusParams()
      const params = {
        searchType: this.search.searchType,
        keyword: this.search.keyword,
        searchStartDt: (this.search.searchStartDate && moment(this.search.searchStartDate).format('yyyy-MM-DD HH:mm:ss')) || null,
        searchEndDt: ( this.search.searchEndDate && moment(this.search.searchEndDate).format('yyyy-MM-DD HH:mm:ss')) || null,
        status: selectStatus.toString(),
      }
      
      api.payment.downloadExcel(params, (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `결제내역_${new Date().toISOString()}.xlsx`);
        document.body.appendChild(link);
        link.click();
      })
    },
    getPagingList(page) {
      const selectStatus = this.getSearchStatusParams()
      const params = {
        searchType: this.search.searchType,
        keyword: this.search.keyword,
        searchStartDt: (this.search.searchStartDate && moment(this.search.searchStartDate).format('yyyy-MM-DD HH:mm:ss')) || null,
        searchEndDt: ( this.search.searchEndDate && moment(this.search.searchEndDate).format('yyyy-MM-DD HH:mm:ss')) || null,
        status: selectStatus.toString(),
        page: page || 1,
      }

      this.isLoading = true
      this.payments = []
      api.payment.list(params,(response) => {
        const {content, totalPages, totalElements} = response.data
        this.payments = content
        this.currentPage = page
        this.totalPage = totalPages
        this.totalRows = totalElements
        this.isLoading = false
      }, (err) => {
        console.log(err)
      })
    },
    changeSearchStartDate(modelData) {
      console.log(moment(modelData).format('yyyy-MM-DD HH:mm:ss'))
      this.search.searchStartDate = moment(modelData)
    }
  }
}
</script>
<style>
.datepicker{
  width: 250px;
}
.selector{
  width: 150px;
}
</style>
